import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '@/components/header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import DescribeImageWithDataset from '@/routes/(app)/(tasks)/components/describe-image-with-dataset';
import DescribeImageWithFile from '@/routes/(app)/(tasks)/components/describe-image-with-file';

const DescribeImageTab = {
  WITH_DATASET: 'describe-image-with-dataset',
  WITH_FILE: 'describe-image-with-file',
} as const;

const DescribeImage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header
        title={t(`tasks.describeImage.title`)}
        description={t(`tasks.describeImage.description`)}
      />

      <Tabs defaultValue={DescribeImageTab.WITH_DATASET}>
        <TabsList>
          <TabsTrigger value={DescribeImageTab.WITH_DATASET}>
            {t('tasks.describeImage.withDataset.title')}
          </TabsTrigger>
          <TabsTrigger value={DescribeImageTab.WITH_FILE}>
            {t('tasks.describeImage.withFile.title')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value={DescribeImageTab.WITH_DATASET}>
          <DescribeImageWithDataset />
        </TabsContent>
        <TabsContent value={DescribeImageTab.WITH_FILE}>
          <DescribeImageWithFile />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default DescribeImage;
